/* eslint-disable no-restricted-globals */
/* eslint-disable no-sequences */
/* eslint-disable react/prop-types */
/* eslint-disable no-empty */
import React, { useState, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { v4 as uuid } from 'uuid';
import { Marker, Circle, Polygon } from 'react-leaflet';
import * as Yup from 'yup';
import Firebase from '../services/firebase';
import PosicoesContext from '../context/posicoes.context';
import { constantes } from '../constantes';
import UsuarioContext from '../context/usuario.context';
import FirebaseContext from '../context/firebase.context';
import { DataAtual, CalcularDistancia } from '../functions/helper';
import { notify } from '../functions/notifications';
import Navbar from '../components/navbar';
import CidadesContext from '../context/cidades.context';
import { NotificacaoFake, NotificarTodosOsUsuarios } from '../services/apiWhats';

export function ProviderPosicoes({ children }) {
  const { usuario, setUsuario, userLocation } = useContext(UsuarioContext);
  const { setActualLocation, actualLocation, listUf } = useContext(CidadesContext);
  const {
    positionViwerActive, positionViwerInative,
    expectadores,
  } = useContext(FirebaseContext);
  const [temp, setTemp] = useState({ positions: [{ lat: 0, lng: 0 }] });
  const [nowMarker, setNowMarker] = useState([0, 0]);
  const [coords, setCoords] = useState({ lat: '', lng: '' });
  const [nowPoligon, setNowPoligon] = useState([]);
  const [iconeClick, setIconeClick] = useState();
  const [nowCoordenadas, setNowCoordenadas] = useState({ lat: '', lng: '' });
  const [filtrar, setFiltrar] = useState(false);
  const [input, setInput] = useState({});
  const [positionsViwer, setPositionViwer] = useState(false);
  const [positionsViwerActive, setPositionViwerActive] = useState(false);
  const [isScreenCertifield, setIsScreenCertifield] = useState(false);
  const [sizePosition, setSizePosition] = useState(0);
  const [showPopUp, setShowPopUp] = useState(false);
  const [checkNumber, setCheckNumber] = useState({ type: 0, value: 0 });
  const [enableIputHeader, setEnabledInputHeader] = useState(
    { estado: false, cidade: false, tipo: false },
  );
  const [inputsVerificacao, setInputsVerificacao] = useState({
    apiarioRegistrado: false,
    apiarioCertificado: false,
    apiarioPermanente: false,
  });
  const { tipoCadastro } = constantes;
  const [clickPopUp, setClickPopUp] = useState({});

  function cancelRecord() {
    setNowPoligon([],
      setInput({}),
      setCheckNumber({ type: 0, value: 0 }),
      setEnabledInputHeader({ estado: false, cidade: false, tipo: false }),
      setCoords({ lat: '', lng: '' }),
      setSizePosition(0),
      setNowCoordenadas({ lat: '', lng: '' }),
      setNowMarker([0, 0]));
    if (temp.type === 'marker') setTemp({ tipo: 'Selecione', positions: [{ lat: 0, lng: 0 }] });
    if (temp.type === 'poligon') setTemp({ tipo: 'Selecione', positions: [] });
  }
  function verificaTipoDeIcone() {
    try {
      const tipo = document.getElementById('tipo').value;
      if (tipo) {
        // Essa função que seleciona o tipo de icone usar
        const { icone, tipo: mORp } = tipoCadastro.find((result) => result.valor === tipo);
        if (icone) setIconeClick(icone);

        // Reseta as posições inversamente, caso o usuário troque o tipo de cadastro.
        if (mORp === 'marker') {
          if (nowPoligon !== []) setNowPoligon([]);
        } else if (nowMarker !== [0, 0]) setNowMarker([0, 0]);
      }
    } catch (error) {}
  }
  function resetAll() {
    cancelRecord();
  }
  function retornaIcone(props) {
    const { icone, cor, raio } = tipoCadastro.find((result) => result.valor === props);
    if (icone) setIconeClick(icone);
    return [icone, cor, raio];
  }
  function reducePositions(props) {
    const result = props.map((e) => JSON.stringify(e))
      .reduce((acc, cur) => (acc.includes(cur) || acc.push(cur), acc), [])
      .map((e) => JSON.parse(e));
    setFiltrar(false);
    setSizePosition(result.length);
    setTemp((prevState) => (
      {
        ...prevState,
        positions: result,
      }
    ));
    return result;
  }
  function updateDate(newUser) {
    const { uid } = usuario;

    Firebase.firestore()
      .collection('ids_cadastro')
      .doc('numeracao').update({
        [`${temp.estado}`]: (temp.idEstado + 1),
      })
      .then(() => {
        expectadores.forEach(({ nome, celular }) => {
          NotificacaoFake({
            celular,
            nome,
            data: temp.data,
            horaInicial: temp.horaInicial,
            horaFinal: temp.horaFinal,
            tipo: temp.modalidade,
            produto: temp.produtoAplicacao,
            cidade: temp.cidade,
            estado: temp.estado,
          });
        });

        Firebase.firestore().collection('users').doc(uid).update(newUser)
          .then(() => {
            if (temp.tipo === constantes.classificacao.aplicador) {
              NotificarTodosOsUsuarios(
                {
                  data: temp.data,
                  horaInicial: temp.horaInicial,
                  horaFinal: temp.horaFinal,
                  tipo: temp.modalidade,
                  produto: temp.produtoAplicacao,
                  uidSender: uid,
                  latUser: temp.positions[0].lat,
                  lngUser: temp.positions[0].lng,
                },
              );
            }
            cancelRecord();
            setUsuario(newUser, notify('success', 'Dados Salvos'));
          })
          .catch(() => {
            cancelRecord();
            setUsuario(newUser, notify('success', 'Dados Salvos'));
          });
      });
  }
  function SaveNewPositions() {
    try {
      const {
        uid: uuidCad, type, tipo, cidade,
      } = temp;
      if (cidade === '') temp.cidade = document.querySelector('#cidade-header').value;
      const { records: { marker, poligon } } = usuario;
      const newUuid = uuid();

      const notifications = (tipo === constantes.classificacao.aplicador)
        ? [
          ...usuario.notifications, {
            [`${newUuid}`]: {
              body: `${usuario.nome.split(' ')[0]}, os usuários que possuem culturas próxima a sua aplicação foram notificados.`,
              data: DataAtual(),
              read: false,
              title: `${usuario.nome.split(' ')[0]}, usuários notificados.`,
              uid: newUuid,
            },
          },
        ]
        : [
          ...usuario.notifications,
        ];

      const newUser = (type === 'poligon') ? {
        ...usuario,
        ...userLocation,
        notifications,
        records: {
          marker,
          poligon: [
            ...poligon, { [`${uuidCad}`]: temp },
          ],
        },
      } : {
        ...usuario,
        ...userLocation,
        records:
      {
        poligon,
        marker: [
          ...marker, { [`${uuidCad}`]: temp },
        ],
      },
      };
      updateDate(newUser);
    } catch (error) {
      if (!error.message) return null;
    }
  }
  function verificaTipo() {
    const tipoValor = document.querySelector('#tipo').value;
    try {
      const { valor, tipo } = constantes.tipoCadastro
        .find((result) => result.valor === usuario.tipoDeCadastro);
      const result = [...usuario.premissoes, { permitido: { valor, tipo } }];
      const { tipo: verifica } = result.find((t) => t.permitido.valor === tipoValor).permitido;
      return verifica;
    } catch (error) {
      return { tipo: undefined };
    }
  }
  function clearLast() {
    if (verificaTipo() === 'marker') {
      cancelRecord();
    } else {
      const MAX_LIMIT = sizePosition - 1;
      const erasedP = temp.positions.filter((item, index) => (index < (MAX_LIMIT) && item));
      if (erasedP.length === 0) {
        cancelRecord();
      } else {
        setTemp((prevState) => ({
          ...prevState,
          positions: erasedP,
        }));
        setSizePosition(erasedP.length);
      }
    }
  }
  function setarInformacoes({ target: { name, value } }) {
    const type = verificaTipo();
    const dataExp = 'Indeterminado';
    const {
      celular,
      fone,
      uid: uidUsuario,
      idUsuario,
      nome,
    } = usuario;

    let { estado, cidade } = temp;

    if (!temp.estado) {
      const estadoId = document.querySelector('#estado-header').value;
      for (let index = 0; index < listUf.length; index += 1) {
        const element = listUf[index];
        if (listUf[index].id === parseInt(estadoId, 10)) {
          estado = element.sigla;
          cidade = '';
        }
      }
    }

    const valoresObrigatorios = {
      active: false,
      celular,
      fone,
      uidUsuario,
      idUsuario,
      cidade,
      estado,
      nome,
      type,
      tipo: temp.tipo ? temp.tipo : 'Selecione',
      dataCad: DataAtual(),
      dataAprov: '00/00/0000',
      dataExp,
      uid: uuid(),
    };
    let idEstado = isNaN(temp.idEstado) ? false : temp.idEstado;

    if (!idEstado && temp.estado) {
      Firebase.firestore()
        .collection('ids_cadastro')
        .doc('numeracao').get()
        .then((resultado) => {
          idEstado = resultado.data()[`${temp.estado}`];
          if (name === 'latitude' || name === 'longitude') {
            const { positions: { lat, lng } } = temp;
            setTemp((prevState) => (
              {
                ...prevState,
                ...valoresObrigatorios,
                idEstado,
                positions: [
                  {
                    lat: name === 'latitude' ? parseFloat(value) : lat,
                    lng: name === 'longitude' ? parseFloat(value) : lng,
                  },
                ],
              }
            ));
          } else {
            setTemp((prevState) => (
              {
                ...prevState,
                ...valoresObrigatorios,
                idEstado,
                [name]: value,
              }
            ));
          }
        })
        .catch((err) => console.log(err));
    }
    if (name === 'latitude' || name === 'longitude') {
      const { positions: { lat, lng } } = temp;
      setTemp((prevState) => (
        {
          ...prevState,
          ...valoresObrigatorios,
          idEstado,
          positions: [
            {
              lat: name === 'latitude' ? parseFloat(value) : lat,
              lng: name === 'longitude' ? parseFloat(value) : lng,
            },
          ],
        }
      ));
    } else {
      setTemp((prevState) => (
        {
          ...prevState,
          ...valoresObrigatorios,
          idEstado,
          [name]: value,
        }
      ));
    }
  }
  function setarInformacoesClick({ lat, lng }) {
    const type = verificaTipo();
    const dataExp = 'Indeterminado';
    const { value: cidade } = document.querySelector('#cidade-header');
    const {
      celular,
      fone,
      uid: uidUsuario,
      idUsuario,
      nome,
    } = usuario;

    const valoresObrigatorios = {
      active: false,
      celular,
      cidade,
      fone,
      idUsuario,
      uidUsuario,
      nome,
      type,
      tipo: temp.tipo ? temp.tipo : 'Selecione',
      dataCad: DataAtual(),
      dataAprov: '00/00/0000',
      dataExp,
      uid: uuid(),
    };

    if (type === 'marker') {
      setTemp((prevState) => (
        {
          ...prevState,
          ...valoresObrigatorios,
          positions: [
            { lat, lng },
          ],
        }
      ), setNowMarker([lat, lng]), setNowCoordenadas(() => ({ lat, lng })));
    } else if (type === 'poligon') {
      setTemp((prevState) => (
        {
          ...prevState,
          ...valoresObrigatorios,
          positions: [...prevState.positions, { lat, lng }],
        }
      ));
    }
  }
  function RemoveValueTemp() {
    const { apiarioRegistrado, apiarioCertificado, apiarioPermanente } = inputsVerificacao;

    let verify = [];

    if (temp.tipo === constantes.classificacao.sericicultura) {
      if (apiarioCertificado) {
        verify = [...verify, 'certificadora', 'codCertificadora'];
      }
    } else {
      if (!apiarioRegistrado) {
        verify = [...verify, 'associacao'];
      }
      if (!apiarioCertificado) {
        verify = [...verify, 'certificadora', 'codigoCertificadora'];
      }
      if (!apiarioPermanente) {
        verify = [...verify, 'dataInicial', 'dataFinal'];
      }
    }

    let newObj = {};
    let received = Object.entries(temp)
      .map((filtro) => filtro)
      .filter((mount) => mount && mount)
      .map((result) => ({ [`${result[0]}`]: result[1] }));
    verify.forEach((item) => {
      received = received.map((result) => (Object.keys(result)[0] !== item) && result)
        .filter((mount) => mount && mount);
    });

    received.forEach((value) => {
      newObj = {
        ...newObj,
        [`${Object.keys(value)}`]: Object.values(value)[0],
      };
    });
    setTemp(newObj);
  }
  async function formataLatLng() {
    const { type, value } = checkNumber;
    const numero = value.toString();
    const permitidos = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', '-'];
    const ultimoDigitado = numero.substring(numero.length - 1);
    const permitido = permitidos.includes(ultimoDigitado);
    const numverificado = permitido
      ? numero.replaceAll('.', '').replaceAll('-', '')
      : numero.substring(0, numero.length - 1).replaceAll('.', '').replaceAll('-', '');

    const verificar = Yup.object().shape({
      valor: Yup.number().required(),
    });

    if ((await verificar.isValid({ valor: parseFloat(numverificado) }))
    && numverificado.length > 2) {
      const nFormatado = `${numverificado.substring(0, 2)}.${numverificado.substring(2)}`;
      setCoords((prevState) => ({
        ...prevState, [`${type}`]: parseFloat(`-${nFormatado}`),
      }));
      setNowCoordenadas((prevState) => ({ ...prevState, [`${type}`]: parseFloat(`-${nFormatado}`) }));
    } else {
      setCoords((prevState) => ({
        ...prevState, [`${type}`]: numverificado,
      }));
      setNowCoordenadas((prevState) => ({ ...prevState, [`${type}`]: numverificado }));
    }
  }
  async function verificaAgrupamento() {
    const check = Yup.object().shape({
      descricaoAgrupamento: Yup.string().default(() => {
        throw new Error('Informe a descrição.');
      }),

      positions: Yup.object({
        lat: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
        lng: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
      }).nullable(),
    });

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  async function verificaEscola() {
    const check = Yup.object().shape({
      descricaoEscola: Yup.string().default(() => {
        throw new Error('Informe a descrição.');
      }),

      positions: Yup.object({
        lat: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
        lng: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
      }).nullable(),
    });

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  async function verificaColeta() {
    const check = Yup.object().shape({
      descricaoColeta: Yup.string().default(() => {
        throw new Error('Informe a descrição.');
      }),

      positions: Yup.object({
        lat: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
        lng: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
      }).nullable(),
    });

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  async function verificaMoradia() {
    const check = Yup.object().shape({
      descricaoMoradia: Yup.string().default(() => {
        throw new Error('Informe a descrição.');
      }),

      positions: Yup.object({
        lat: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
        lng: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
      }).nullable(),
    });

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  async function verificaReserva() {
    const check = Yup.object().shape({
      descricaoReserva: Yup.string().default(() => {
        throw new Error('Informe a descrição.');
      }),

      positions: Yup.object({
        lat: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
        lng: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
      }).nullable(),
    });

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  async function verificaAplicacao() {
    const check = Yup.object().shape({
      horaFinal: Yup.string().default(() => {
        throw new Error('Informe a hora final.');
      }),
      horaInicial: Yup.string().default(() => {
        throw new Error('Informe a hora inicial.');
      }),
      data: Yup.string().default(() => {
        throw new Error('Informe a data.');
      }),
      modalidade: Yup.string().default(() => {
        throw new Error('Informe a modalidade.');
      }),
      produtoAplicacao: Yup.string().default(() => {
        throw new Error('Informe o produto.');
      }),
      tratamento: Yup.string().default(() => {
        throw new Error('Informe o tratamento.');
      }),
    });

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  async function verificaRios() {
    const check = Yup.object().shape({
      descricaoRios: Yup.string().default(() => {
        throw new Error('Informe a descrição.');
      }),

      positions: Yup.object({
        lat: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
        lng: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
      }).nullable(),
    });

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  async function verificaAmoreira() {
    const check = Yup.object().shape({
      associacaoAmoreira: Yup.string().required().default(() => {
        throw new Error('Informe a associação.');
      }),
      manejoAmoreira: Yup.string().required().default(() => {
        throw new Error('Informe o manejo.');
      }),
    });

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  function verificaApiario() {
    const check = Yup.object().shape({

      dataFinal: Yup.string().default(() => {
        if (temp.localizacaoapiario === 'Apiário Móvel') {
          throw new Error('Informe a data final.');
        }
      }),

      dataInicial: Yup.string().default(() => {
        if (temp.localizacaoapiario === 'Apiário Móvel') {
          throw new Error('Informe a data inicial.');
        }
      }),

      codigocertificadoraApicultura: Yup.string().default(() => {
        if (temp.apiarioRegistrado === 'Sim' && temp.apiarioCertificado === 'Sim') {
          throw new Error('Informe o código da certificação.');
        }
      }),

      certificadoraApicultura: Yup.string().default(() => {
        if (temp.apiarioRegistrado === 'Sim' && temp.apiarioCertificado === 'Sim') {
          throw new Error('Informe a certificadora.');
        }
      }),

      associacao: Yup.string().default(() => {
        if (temp.apiarioRegistrado === 'Sim') {
          throw new Error('Informe a associação.');
        }
      }),

      quandidadeColmeias: Yup.number().min(1).default(() => {
        throw new Error('Informe a quantidade de colméias.');
      }),

      positions: Yup.object({
        lat: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
        lng: Yup.number().test(
          'diferente de 0',
          'Informe uma posição no mapa',
          (value) => value !== 0,
        ),
      }).nullable(),

      descricaoApicultura: Yup.string().default(() => {
        throw new Error('A descrição é obrigatória.');
      }),
    }).required();

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  function verificaSericicultura() {
    const check = Yup.object().shape({

      codigoSericicultor: Yup.string().default(() => {
        if (temp.sericicultorCertificado === 'Sim') {
          throw new Error('Informe o código.');
        }
      }),

      certificadoraSericicultor: Yup.string().default(() => {
        if (temp.sericicultorCertificado === 'Sim') {
          throw new Error('Informe a certificadora.');
        }
      }),

      manejoSericicultura: Yup.string().required().default(() => {
        throw new Error('O manejo é obrigatório.');
      }),

      associacaoSericicultura: Yup.string().required().default(() => {
        throw new Error('A associação é obrigatória.');
      }),

      descricaoSericicultura: Yup.string().default(() => {
        throw new Error('A descrição é obrigatório');
      }),
    }).required();

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  function verificaCultura() {
    const check = Yup.object().shape({

      codcertificadoraCultura: Yup.string().default(() => {
        if (temp.culturaCertificada === 'Sim') {
          throw new Error('Informe o código.');
        }
      }),

      certificadoraCultura: Yup.string().default(() => {
        if (temp.culturaCertificada === 'Sim') {
          throw new Error('Informe a certificadora.');
        }
      }),

      culturaManejo: Yup.string().required().default(() => {
        throw new Error('Informe o manejo.');
      }),

      cultura: Yup.string().default(() => {
        throw new Error('O tipo de cultura é obrigatório');
      }),
    }).required();

    check.validate(temp).then(() => {
      SaveNewPositions();
    }).catch((err) => {
      const { message } = err;
      return notify('error', message);
    });
  }
  function removeEmptyValues() {
    let newObj = {};

    let received = Object.entries(temp)
      .map((filtro) => filtro)
      .filter((mount) => mount && mount)
      .map((result) => ({ [`${result[0]}`]: result[1] }));

    received = received.map((result) => (
      result[`${Object.keys(result)[0]}`] && result[`${Object.keys(result)[0]}`] !== ''
    ) && result)
      .filter((mount) => mount && mount);

    received.forEach((value) => {
      newObj = {
        ...newObj,
        [`${Object.keys(value)}`]: Object.values(value)[0],
      };
    });

    if (!newObj.propositoApicultura && newObj.tipo === constantes.classificacao.apicultura) {
      newObj = {
        ...newObj,
        apiarioRegistrado: 'Não',
        apiarioCertificado: 'Não',
        apiarioPermanente: 'Apiário Permanente',
        propositoApicultura: 'Hobby',
      };
      return setTemp(newObj);
    } if (newObj.apiarioRegistrado && newObj.apiarioRegistrado === 'Não') {
      newObj = {
        ...newObj,
        apiarioCertificado: 'Não',
        apiarioPermanente: 'Apiário Permanente',
        propositoApicultura: 'Hobby',
      };
      return setTemp(newObj);
    }

    if (!newObj.culturaCertificada && newObj.tipo === constantes.classificacao.cultura) {
      newObj = {
        ...newObj,
        culturaCertificada: 'Sim',
        possuiCodigoCultura: 'Sim',
      };
      return setTemp(newObj);
    } if (newObj.culturaCertificada && (newObj.culturaCertificada === 'Não' && newObj.tipo === constantes.classificacao.cultura)) {
      newObj = {
        ...newObj,
        possuiCodigoCultura: 'Sim',
        culturaCertificada: 'Não',
      };
      return setTemp(newObj);
    }
    if (!newObj.tratamento && newObj.tipo === constantes.classificacao.aplicador) {
      newObj = {
        ...newObj,
        tratamento: 'Ad Foliar',
        modalidade: 'Aérea',
      };
      return setTemp(newObj);
    }
    if (!newObj.sericicultorCertificado && newObj.tipo
      === constantes.classificacao.sericicultura) {
      newObj = {
        ...newObj,
        possuiCodigoSericicultura: 'Sim',
        sericicultorCertificado: 'Sim',
      };
      return setTemp(newObj);
    }

    return setTemp(newObj);
  }
  function verificarCentroPolygon(props) {
    let minLat = props[0].lat;
    let maxLat = props[props.length - 1].lat;
    let minLng = props[0].lng;
    let maxLng = props[props.length - 1].lng;

    props.forEach(({ lat, lng }) => {
      if (lat >= minLat) {
        minLat = lat;
      }
      if (lat <= maxLat) {
        maxLat = lat;
      }
      if (lng >= minLng) {
        minLng = lng;
      }
      if (lng <= maxLng) {
        maxLng = lng;
      }
    });

    const medLat = (maxLat - minLat) / 2;
    const medLng = (maxLng - minLng) / 2;
    const latCenter = minLat + medLat;
    const lngCenter = minLng + medLng;
    return [latCenter, lngCenter];
  }
  function getRecords() {
    Firebase.firestore()
      .collection('users')
      .get()
      .then((result) => {
        const envios = result.docs.map((user) => user.data().records);
        const markers = envios.map((mark) => mark.marker.length > 0 && mark.marker);
        const poligon = envios.map((pol) => pol.poligon.length > 0 && pol.poligon);
        const markerAndPoligon = [...markers, ...poligon];
        const listPosition = [];
        const { raiosExibicao: { cadastros } } = constantes;
        markerAndPoligon.forEach((listMarkerAndPoligon) => {
          if (listMarkerAndPoligon) {
            listMarkerAndPoligon.forEach((position) => (
              listPosition.push(position)
            ));
          }
        });

        const listMarkerAndPoligon = listPosition.map((item) => {
          const key = Object.keys(item)[0];
          const { aplicador, coleta } = constantes.classificacao;
          const {
            type, positions, tipo, uidUsuario, active,
          } = item[`${key}`];
          const { lat, lng } = positions[0];
          const { uid, tipoDeCadastro, superUsuario } = usuario;
          const raio = CalcularDistancia({
            lat1: usuario.latitude,
            lon1: usuario.longitude,
            lat2: lat,
            lon2: lng,
          });

          if (active || uidUsuario === (uid || superUsuario || tipoDeCadastro === coleta)) {
            if (uidUsuario === uid || superUsuario
              || (raio && (cadastros > raio))
              || (tipoDeCadastro === aplicador || tipoDeCadastro === coleta)) {
              if (
                (type === 'marker' && superUsuario)
                || (type === 'marker' && (uidUsuario === uid || (tipoDeCadastro === aplicador
                  || tipoDeCadastro === coleta)))) {
                return (
                  <>
                    <Marker
                      class="marker-marker"
                      position={[lat, lng]}
                      icon={retornaIcone(tipo)[0]}
                      eventHandlers={{
                        click() {
                          setClickPopUp(item[key],
                            setShowPopUp(true));
                        },
                      }}
                    />
                    <Circle
                      weight={1}
                      stroke
                      center={[lat, lng]}
                      radius={retornaIcone(tipo)[2]}
                      pathOptions={{ color: retornaIcone(tipo)[1] }}
                    />
                  </>
                );
              }
              if (
                (type === 'poligon' && superUsuario)
                || (tipoDeCadastro === coleta) || (type === 'poligon' && (uidUsuario === uid || tipoDeCadastro === aplicador))) {
                return (
                  <>
                    <Polygon
                      weight={1}
                      color={retornaIcone(tipo)[1]}
                      positions={[...positions]}
                    />
                    <Marker
                      class="marker-poligon"
                      position={verificarCentroPolygon([...positions])}
                      icon={retornaIcone(tipo)[0]}
                      eventHandlers={{
                        click() {
                          setClickPopUp(item[key],
                            setShowPopUp(true));
                        },
                      }}
                    />
                  </>
                );
              }
            }
          }

          return null;
        });
        setPositionViwer(listMarkerAndPoligon);
      });
  }

  useEffect(() => {
    const MAX_TIME = 1000;
    if (
      (coords.lat !== actualLocation[0] && coords.lng !== actualLocation[1])
        && (coords.lat && coords.lng)) {
      setTimeout(() => {
        setNowMarker([coords.lat, coords.lng]);
        setActualLocation([coords.lat, coords.lng]);
        setNowCoordenadas(() => ({ lat: coords.lat, lng: coords.lng }));
        setTemp((prevState) => ({
          ...prevState,
          positions: [
            {
              lat: coords.lat, lng: coords.lng,
            },
          ],
        }));
      }, MAX_TIME);
    }
  }, [coords]);

  useEffect(() => {
    formataLatLng();
  }, [checkNumber]);

  useEffect(() => {
    if (nowMarker[0]) {
      setCoords({
        lat: nowMarker[0].lat,
        lng: nowMarker[0].lng,
      });
      setTemp((prevState) => (
        {
          ...prevState,
          positions: [
            {
              lat: nowMarker[0],
              lng: nowMarker[1],
            },
          ],
        }
      ));
    }
  }, [nowMarker]);

  useEffect(() => {
    RemoveValueTemp();
  }, [inputsVerificacao]);

  useEffect(() => {
    if (temp.tipo === constantes.classificacao.apicultura) {
      setTemp(() => ({
        apiarioRegistrado: 'Não',
        apiarioCertificado: 'Não',
        apiarioPermanente: 'Apiário Permanente',
        proposito: 'Hobby',
      }));
    }
    if (temp.tipo) setIconeClick(tipoCadastro[0].icone);
    removeEmptyValues();
  }, [temp.tipo]);

  useEffect(() => {
    if (temp.type) {
      if (temp.type === 'poligon') {
        setTemp((prevState) => ({
          ...prevState,
          positions: [],
        }));
      } else {
        setTemp((prevState) => ({
          ...prevState,
          positions: [{ lat: 0, lng: 0 }],
        }));
      }
    }
  }, [temp.type]);

  useEffect(() => {
    if (temp.positions.length > 0 && sizePosition < temp.positions.length) {
      setFiltrar(true);
    }
  }, [temp.positions]);

  useEffect(() => {
    if (filtrar) {
      reducePositions(temp.positions);
    }
  }, [filtrar]);

  useEffect(() => {
    getRecords();
  }, [usuario.records, positionViwerActive, positionViwerInative]);

  useEffect(() => {
    verificaTipoDeIcone();
  }, [temp]);

  const shared = {
    positionsViwer,
    clickPopUp,
    setClickPopUp,
    setPositionViwer,
    temp,
    verificaSericicultura,
    retornaIcone,
    setTemp,
    clearLast,
    nowMarker,
    nowPoligon,
    cancelRecord,
    setarInformacoes,
    setarInformacoesClick,
    SaveNewPositions,
    setNowPoligon,
    setNowMarker,
    iconeClick,
    setIconeClick,
    resetAll,
    checkNumber,
    setCheckNumber,
    coords,
    setCoords,
    inputsVerificacao,
    setInputsVerificacao,
    RemoveValueTemp,
    verificaAgrupamento,
    removeEmptyValues,
    nowCoordenadas,
    setNowCoordenadas,
    verificaReserva,
    verificaEscola,
    verificaMoradia,
    verificaRios,
    verificaApiario,
    verificaAmoreira,
    verificaCultura,
    verificaAplicacao,
    enableIputHeader,
    setEnabledInputHeader,
    positionsViwerActive,
    setPositionViwerActive,
    input,
    verificaColeta,
    setInput,
    showPopUp,
    setShowPopUp,
    isScreenCertifield,
    setIsScreenCertifield,
  };

  return (
    <>
      <PosicoesContext.Provider value={{ ...shared }}>
        {(usuario.uid && !isScreenCertifield) && <Navbar />}
        {children}
      </PosicoesContext.Provider>
    </>
  );
}
ProviderPosicoes.propTypes = {
  children: PropTypes.node.isRequired,
};
